import { Preloader } from '@/components/ui/Preloader';
import useOpen from '@/hooks/useOpen';
import { getContext, isContextAvailable } from '@/miniappContext';
import analytics, { buildSettings, ScreenActionType } from '@/utils/analytics';
import { closeMiniapp } from '@/utils/closeMiniapp';

import { AIWardrobe } from './AIWardrobe';
import { ErrorBoundary } from './ErrorBoundary';

const isStandalone = typeof window !== 'undefined' && window.parent === window;

function App() {
  const sdkOpen = useOpen();
  const isReady = sdkOpen || isStandalone;

  const isInEditor = isContextAvailable() && (getContext().general.location.getState().route?.includes('/create/editor') ?? false);

  const handleClose = async () => {
    analytics.screenAction({ action: ScreenActionType.CLOSE, settings: buildSettings() });
    await closeMiniapp();
  };

  if (!isReady) return <Preloader />;

  return (
    <ErrorBoundary>
      <AIWardrobe onClose={isInEditor ? handleClose : undefined} />
    </ErrorBoundary>
  );
}

export default App;
